<template>
  <div>
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">公司主页</span>
      </p>
    </header>
    <div style="margin: 90px 0">
    <h3 style="width: 90%;margin: auto">{{list.name}}</h3>
      <div class="comPage">
        <div class="comtitleLeft">
          <p>{{list.short_name}}</p>
          <p class="comtitleLeftP">{{list.trade}}</p>
        </div>
        <div class="comtitle">
          <img src="@/assets/img/tx.jpg" alt="">
        </div>
      </div>
      <div class="comPageR">
        <p>公司成员</p>
        <p class="comPageRImg">{{list.scale}}人 </p>
      </div>

      <div class="comIntroduce">
        <div class="line"></div>
        <div class="liner">
          <p>公司介绍</p>
        </div>
        <p style="text-align: center">{{list.desc}}</p>
        <!--<p>上社保网隶属于北京瑞明科技有限公司，是一家及社保、公积金管理，商业保险及劳务管理服务于一体的专业在-->
        <!--线人力资源综合性服务平台-->
        <!--</p>-->
      </div>
      <div class="comIntroduce">
        <div class="line"></div>
        <div class="liner">
          <p>企业邮箱</p>
        </div>
        <p class="comCenter">{{list.email}}</p>
      </div>
      <div class="comIntroduce">
        <div class="line"></div>
        <div class="liner">
          <p>一句话介绍</p>
        </div>
        <p class="comCenter">{{list.one_desc}}</p>
      </div>
      <div class="comIntroduce">
        <div class="line"></div>
        <div class="liner">
          <p>公司网址</p>
        </div>
        <p class="comCenter">{{list.web}}</p>
      </div>
      <div class="comIntroduce">
        <div class="line"></div>
        <div class="liner">
          <p>公司地址</p>
        </div>
        <p class="comCenter">{{list.address}}</p>
      </div>
    </div>
    <van-tabbar route v-model="active">
      <van-tabbar-item replace to="/comTalents" icon="wap-home-o">
        找人才
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMessage" icon="envelop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/comPosition" icon="desktop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMy" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true,
        activeName: 'a',
        active:0,
        list:{}
      }
    },
    mounted(){
   this.getComHomePager()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      getComHomePager() {
        console.log(111)
        this.$api.getComHomePage({'id':this.$route.params.id}).then(res=>{
          this.list=res.data?res.data:{}
          console.log(this.list)
        }).catch(err=>{

        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  .headerSpan{
    margin-left: 1rem;
    line-height: 10px;
    color: #FFFFFF;
  }
  header{
    width: 100%;
    height: 80px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .comtitle{
    width: 60px;
    height: 60px;
  }
  .comtitle img{
    width: 100%;
    border-radius: 100%;
  }
  .comtitleLeft{

  }
  .comPage{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: auto;
    border-bottom: solid 1px #DEDEDE;
  }
.comtitleLeftP{
  font-size: 13px;
  color: grey;
}
  .comPageR{
    display:flex;
    justify-content: space-between;
    width: 90%;
    margin: auto;
    border-bottom: solid 10px #F8F8F8;
    /*background-image:url('../../assets/img/gonext.png');*/
    /*background-repeat: no-repeat;*/
    /*background-position: 98% center;*/
    /*background-size: 7px 15px;*/
    /*background: url(../img/gonext.png)*/
  }
  .comPageRImg{
    background-image:url('../../assets/img/gonext.png');
    background-repeat: no-repeat;
    background-position: 98% center;
    background-size: 7px 15px;
    padding-right: 1rem;
  }
.line{
  width: 66%;
  height: 1px;
  background-color: #d2d2d2;
  position: relative;
  /*top: 50%;*/
  left: 17%;
  top: 28px;
}
  .comIntroduce{
    width: 90%;
    font-size: 15px;
    margin: auto;
  }
  .liner{
    text-align: center;
    width: 120px;
    height: 22px;
    line-height: 22px;
    margin: 0 auto;
    background-color: #fff;
    position: relative
  }
  .comCenter{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/comHomePage.vue